import { render } from "./customer-details-invoice.vue?vue&type=template&id=3ea76e84"
import script from "./customer-details-invoice.vue?vue&type=script&lang=js"
export * from "./customer-details-invoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__